import BillingHistoryTable from 'components/tables/billing-history/BillingHistoryTable'
import React from 'react'

const index = () => {
    return (
        <BillingHistoryTable />
    )
}

export default index